import React from "react";
import { Link, useLocation } from "react-router-dom";

const RequisitionTabBar = ({ id }) => {
  const location = useLocation();

  const tabs = [
    { id: "general", label: "General", link: `/requisition/updateRequisition/${id}`, icon: "fa fa-info-circle" },
    { id: "items", label: "Items", link: `/requisition/updateRequisitionItems/${id}`, icon: "fa fa-box" },
  ];

  const getActiveTab = () => {
    if (location.pathname.includes("updateRequisitionItems")) return "items";
    return "general";
  };

  return (
    <ul className="nav nav-tabs nav-tabs-v2 req-tabs px-0 mb-3">
      {tabs.map((tab) => (
        <li className="nav-item me-2" key={tab.id}>
          <Link
            to={tab.link}
            className={`nav-link px-2 ${getActiveTab() === tab.id ? "active" : ""}`}
          >
            <i className={`${tab.icon} me-2`}></i>
            {tab.label}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default RequisitionTabBar;
